/**
 * MCP waitlist → Zoho CRM Web-to-Lead form ("MCP Waitlist", form 2940756000052758001).
 * Hidden values below come from the Zoho-generated embed code and are required for
 * submissions to reach the CRM. Re-copy them if the form is regenerated in Zoho.
 */
export const ZOHO_WEBFORM = {
  action: 'https://crm.zoho.com/crm/WebToLeadForm',
  formName: 'WebToLeads2940756000052758001',
  hidden: {
    xnQsjsdp: '8bd68bf5869271e58972a4ec7c6862a4b84825aafaebec251cf9ab37cd2f0981',
    zc_gad: '',
    xmIwtLD: '065476804567faea09c6b5c718766639b226f0a72d820aa1d701a41824031f6c1ebdd064eaed989749f116e8e44eda78',
    actionType: 'TGVhZHM=',
    returnURL: 'null',
    ldeskuid: '',
    LDTuvid: '',
    // Set automatically for every waitlist signup (shown as a required field in the Zoho embed).
    'Lead Status': 'Enriching Lead',
    // Honeypot — must stay empty.
    aG9uZXlwb3Q: '',
  } as Record<string, string>,
  /** Zoho form analytics script ("Do not remove" in the embed). Loaded when the form renders. */
  analyticsSrc:
    'https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=e04a838b4278aa2b61a3ccb25d2ce268d484f716a646253065c668352360f4c382f93b65ebbbabe000e8fed8c3a41054gid49bd1f874fda482aa0eac80fece52e924b3d7529ba8c0e9441e185f5f2f76ea4gid9b685c8349c15593a38e11f5355af59fc7a8538ae53c7bf1b05ee4b5ff1d00d2gid7726b38de447c994d9e9428875daf61f19616617b22c6e146c1772d4610c577f&tw=94d078074c6c9f24518817542402aa834431421b7d620b97ebe116032d2aa56b&version=v2',
}

/**
 * "Lead Type" (Zoho field LEADCF5) options shown to visitors. Values must match the
 * Zoho picklist exactly; labels are tidied for visitors. Near-duplicate picklist
 * values (e.g. "VC Fund", "Corporates") are omitted from the visitor list.
 */
export const MCP_LEAD_TYPES: { value: string; label: string }[] = [
  { value: 'Venture Capital', label: 'Venture capital' },
  { value: 'PE', label: 'Private equity' },
  { value: 'Family Office', label: 'Family office' },
  { value: 'Angel', label: 'Angel investor' },
  { value: 'Angel Syndicate', label: 'Angel syndicate' },
  { value: 'LP', label: 'LP' },
  { value: 'Accelerator/Incubator', label: 'Accelerator / incubator' },
  { value: 'Corporate', label: 'Corporate' },
  { value: 'Government', label: 'Government' },
  { value: 'Academic', label: 'Academic' },
  { value: 'Institutional', label: 'Institutional' },
  { value: 'Bank/Debt', label: 'Bank / debt provider' },
  { value: 'Startup', label: 'Startup' },
  { value: 'Venture Backed Startup', label: 'Venture-backed startup' },
  { value: 'SME', label: 'SME' },
  { value: 'Vendor', label: 'Vendor' },
  { value: 'Startup Platform/Partner', label: 'Startup platform / partner' },
  { value: 'Referral Partner', label: 'Referral partner' },
  { value: 'Other', label: 'Other' },
]

export const MCP_WAITLIST_PATH = '/mcp#waitlist'

/** Illustrative example: how an investment team could chain agents over MCP. */
export const MCP_EXAMPLE_STEPS = [
  { agent: 'Thesis Fit Agent', action: 'Screen the submission', result: 'Fits 4 of 5 thesis criteria' },
  { agent: 'Gap Analysis Agent', action: 'Identify missing evidence', result: 'No customer revenue breakdown; no cap table' },
  { agent: 'Investment Memo Agent', action: 'Prepare a draft memo', result: 'Draft memo ready for analyst review' },
] as const

export const MCP_SUCCESS_MESSAGE = 'You’re on the MCP access waitlist. We’ll email you when access is available.'
